import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useTranslation } from 'next-i18next'
import { Skeleton } from '~/components/ui/skeleton'
import { SpaceCardNearestStation } from '~/domains/search/components/space-card/space-card-nearest-station'
import { SpaceCardPrice } from '~/domains/search/components/space-card/space-card-price'
import { SpaceCapacity } from '~/domains/spaces/components/atoms/space-capacity'
import { SpaceSurface } from '~/domains/spaces/components/atoms/space-surface'
import { cn } from '~/lib/utils'

export const SpaceCardFooter = ({
	space,
	showDistance,
	className,
	hidePrices = false,
}: {
	space: Space
	showDistance?: boolean
	className?: string
	hidePrices?: boolean
}) => {
	const { t } = useTranslation()

	return (
		<div className={cn('grid grid-cols-4 gap-2 px-4 py-2', className)}>
			<div className='col-span-3 flex flex-col'>
				<div className='flex flex-row items-end font-bold leading-none'>
					<div className='truncate'>{space.title}</div>

					{showDistance && (
						<span
							data-testid='space-distance'
							className='mb-px ml-1 whitespace-nowrap text-slate-500 text-xs'
						>
							{t('space:distance', { distance: space.distance })}
						</span>
					)}
				</div>

				<SpaceCardNearestStation space={space} />

				<div className='flex flex-row gap-3 text-xs'>
					<SpaceCapacity
						space={space}
						className='text-xs'
					/>

					<SpaceSurface
						space={space}
						className='text-xs'
					/>
				</div>
			</div>

			{!hidePrices && (
				<div className='col-span-1'>
					<SpaceCardPrice space={space} />
				</div>
			)}
		</div>
	)
}

SpaceCardFooter.skeleton = () => (
	<>
		<Skeleton className='mb-2 ml-4 h-[16px] w-3/4' />

		<Skeleton className='mb-2 ml-4 h-[12px] w-1/2' />

		<Skeleton className='mb-2 ml-4 h-[12px] w-1/4' />
	</>
)
